export const DNA_MEMBERSHIP_PERMISSION_PATTERN =
  /^DNA_MEMBERSHIP_DDC_(PRODUCTION|DEVELOPMENT|SUPPORT|ACCOUNT_MANAGERS)$/;

export const hasDDCMembership = (permissions: string[] | null): boolean => {
  if (!permissions || !Array.isArray(permissions)) {
    return false;
  }

  return permissions.some(
    permission =>
      typeof permission === "string" &&
      DNA_MEMBERSHIP_PERMISSION_PATTERN.test(permission)
  );
};
